<template>
    <div class="flex flex-col cannotselect ">
        <div style="min-height:35px;margin-bottom: 10px;" 
             class="border-radius-ms flex flex-row flex-center-cz padding-left-l pointer" 
             :style="{paddingLeft: data.level * 15 + 'px'}"
             :class="{'bk-color-hb':!select, 'bk-color-blue':select}"
             @click="selectClick($event, data.id, data.name)">
             <div @click="expand"><img :src="open ? require('@/assets/images/yizhankai.png') :  hasChild ? 
                           require('@/assets/images/weizhankai.png') : require('@/assets/images/wjj.png')" 
                       :class="{'expanded': open && hasChild, 'noexpand':!open && hasChild, 'folder': !hasChild}" 
                       :data-index="data.name"/></div>
             <div class="font-s">{{data.name}}</div>             
        </div>
        <div style="min-height:35px;margin-bottom: 10px;" v-show="open" v-if="hasChild">
            <my-tree v-for="(item, index) in data.children" :data="item" :key="index" :root="root"  ></my-tree>
        </div>
    </div>
</template>
 
<script>

export default {
    name: 'MyTree',//组件递归必须有name属性 不然无法递归    
    props: {
        data: {},
        root: {} 
    },
    data() {
        return {
            select: false,
            open: false 
        }
    },
    computed: {
        hasChild() {
            return this.data.children && this.data.children.length //判断当前子组件有没有数据 
        }
    },
    methods: {
        expand(event) {
            if(this.hasChild) {
                this.open = !this.open
            }
            event.stopPropagation();
        },
        selectClick(event, id, name) {
            console.log("id====",id)
            this.root.selectItemClick(id,name);
            this.select = !this.select;
            if(this.hasChild && !this.open) {
                this.open = true
            }           
            event.stopPropagation();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/tree/Tree.vue